import type { ITransaction } from '@recargas-dominicanas/core/types';
import { formatCurrency, formatVigency } from '@recargas-dominicanas/core/utils';
import { DetailModal } from '../detail-modal/detail-modal.component';
import { DetailModalItem } from '../detail-modal-item/detail-modal-item.component';

import { 
  ModalContent,
  OutlineButton,
  ModalActions
} from '@recargas-dominicanas/core/components';

interface Props {
  open: boolean;
  transaction: ITransaction;
  overlayEnterAnimation?: boolean;
  onAccept: () => void;
  onClose: () => void;
}

export function InsuranceCancelModal(props: Props) {

  const {
    open,
    transaction,
    overlayEnterAnimation,
    onAccept,
    onClose
  } = props;

  return (
    <DetailModal
      open={open} 
      title='Cancelar seguro'
      overlayEnterAnimation={overlayEnterAnimation}
      onClose={onClose}>
      <ModalContent>
        <DetailModalItem title='Compañía' text={transaction.product.name}/>
        <DetailModalItem title='Vehiculo' text={transaction.insurance!.vehicleName}/>
        <DetailModalItem title='Chasis' text={transaction.insurance!.chassis}/>
        <DetailModalItem title='Poliza' text={transaction.insurance!.policy}/>
        <DetailModalItem title='Vigencia' text={formatVigency(transaction.insurance!.vigency)}/>
        <DetailModalItem title='Precio' color='green' text={formatCurrency(transaction.amount)}/>
        <DetailModalItem title='Referencia' text={transaction.insurance!.id}/>
      </ModalContent>
      <ModalActions>
        <OutlineButton 
          text='Confirmar' 
          onClick={onAccept}/>
      </ModalActions>
    </DetailModal>
  );
}
